import { Parser, Skipper, Result, defaultSkip, parserFor } from './common';

export class Sequence<T> implements Parser<T[]> {

  public constructor(private readonly parsers: Parser<T>[],
                     private readonly skip: Skipper = defaultSkip) {
    this.parsers = parsers;
  }

  public parse(str: string): Result<T[]> {
    const { parsers, skip } = this;
    const value = [];
    let next = str;
    for (const parser of parsers) {
      const r = parser.parse(next);
      if (r === undefined) {
        return;
      }
      value.push(r.value);
      next = skip(r.next);
    }
    return { value, next };
  }
}

export function seq<T extends Parser<U>, U>(parsers:T[], skip?: Skipper): Sequence<U>;
export function seq(parsers: any, skip?: Skipper): Sequence<any>;
export function seq(parsers: any, skip?: Skipper) {
  return new Sequence(parsers.map((parser: any) => parserFor(parser, skip)), skip);
}
